import React, { useEffect, useState } from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";
import ContributionSkyline from "../ui/contribution-skyline";

const GITHUB_USERNAME = "Aayushy7777";

// Matches the portfolio's purple accent (#c084f5), lightest → heaviest activity.
const PALETTE = {
  light: ["#e4d4fb", "#c99cf5", "#a855f7", "#8b31d6"],
  dark: ["#3b2160", "#7c3aed", "#a855f7", "#c084f5"],
};

function Github() {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | ready | error

  useEffect(() => {
    let cancelled = false;
    fetch(`https://github-contributions-api.jogruber.de/v4/${GITHUB_USERNAME}`)
      .then((res) => {
        if (!res.ok) throw new Error("Request failed: " + res.status);
        return res.json();
      })
      .then((json) => {
        const list = Array.isArray(json?.contributions)
          ? json.contributions
              .filter((d) => d && typeof d.date === "string")
              .map((d) => ({ date: d.date, count: Number(d.count) || 0 }))
          : [];
        if (!list.length) throw new Error("No contributions returned");
        if (cancelled) return;
        setData(list);
        setStatus("ready");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Row
      style={{
        justifyContent: "center",
        paddingBottom: "10px",
        color: "white",
      }}
    >
      <h1 className="project-heading pb-4" style={{ paddingBottom: "20px" }}>
        Days I <strong className="purple">Code</strong>
      </h1>

      {status === "loading" && (
        <p style={{ textAlign: "center", color: "#a588c0" }}>
          Loading contributions…
        </p>
      )}

      {status === "ready" && (
        <div style={{ width: "100%", maxWidth: "980px" }}>
          <ContributionSkyline data={data} palette={PALETTE} />
        </div>
      )}

      {status === "error" && (
        <GitHubCalendar
          username={GITHUB_USERNAME}
          blockSize={30}
          blockMargin={10}
          color="#c084f5"
          fontSize={20}
        />
      )}
    </Row>
  );
}

export default Github;
